import {apiClient} from "../utils/Api";

export default class DistrictService {

    static getList = (province_id) => {
        return apiClient.get(`/district/list?province_id=`+province_id);
    };

}